"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadlineWrapper = void 0;
exports.TrustpilotLink = TrustpilotLink;
exports.sharedDiv = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _renderRating = require("../../../page-body/sections/smart-testimonials-section/render-rating.js");
var _image = require("@site/pattern-library-core/image");
var _settings = require("@site/pattern-library-core/settings");
/**
 * Local Imports
 */

const sharedDiv = exports.sharedDiv = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "sharedDiv",
  class: "pl-s12yv7ew"
});
const PrimaryPanelContainer = /*#__PURE__*/(0, _react2.styled)(sharedDiv)({
  name: "PrimaryPanelContainer",
  class: "pl-p527dpq",
  vars: {
    "p527dpq-0": [({
      portraitBgImg
    }) => portraitBgImg ? `url(${portraitBgImg})` : 'initial'],
    "p527dpq-2": [({
      tabletPortraitBgImg
    }) => tabletPortraitBgImg ? `url(${tabletPortraitBgImg})` : 'initial'],
    "p527dpq-4": [({
      landscapeBgImg
    }) => landscapeBgImg ? `url(${landscapeBgImg})` : 'initial']
  }
});
const HeadlineWrapper = exports.HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hbnz6g7"
});
const PanelSpacer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PanelSpacer",
  class: "pl-plmgs3x"
});
const Trustpilot = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Trustpilot",
  class: "pl-t7av37f"
});
const Rating = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Rating",
  class: "pl-r4gz7n7"
});
function TrustpilotLink({
  rating,
  trustpilotLogo,
  trustpilotUrl
}) {
  return /*#__PURE__*/_react.default.createElement("a", {
    href: trustpilotUrl,
    rel: "noreferrer",
    "aria-label": "trustpilot",
    target: "_blank"
  }, rating && /*#__PURE__*/_react.default.createElement(Rating, {
    "data-cy": "rating"
  }, (0, _renderRating.renderRating)(rating, 19)), trustpilotLogo && /*#__PURE__*/_react.default.createElement(_image.LazyImage, (0, _extends2.default)({
    dataCy: "trustpilot-logo"
  }, trustpilotLogo, {
    loading: _image.loadingOptions.EAGER
  })));
}
TrustpilotLink.propTypes = {
  // eslint-disable-next-line max-len
  rating: _propTypes.default.oneOf(_settings.TrustPilotRatings),
  trustpilotLogo: _propTypes.default.object,
  trustpilotUrl: _propTypes.default.string
};

/**
 * ComponentName Component.
 *
 * @param {Object} props React props
 * @param {Object} props.primaryPanel Message Right Props
 * @returns {React.ReactElement} ComponentName Component
 * @public
 */

function PrimaryPanel({
  primaryPanel
}) {
  const {
    portrait,
    tabletPortraitBackground,
    landscape,
    rating,
    trustpilotUrl,
    trustpilotLogo,
    eyebrow,
    invert,
    partial
  } = primaryPanel;
  if (primaryPanel?.eyebrowLogo) {
    primaryPanel.eyebrowLogo.loading = _image.loadingOptions.EAGER;
  }
  return /*#__PURE__*/_react.default.createElement(PrimaryPanelContainer, {
    "data-cy": "primary-panel",
    portraitBgImg: portrait.url,
    landscapeBgImg: landscape.url,
    tabletPortraitBgImg: (tabletPortraitBackground || portrait)?.url,
    "data-partial": partial || (invert ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "primary-headline"
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    headlineTag: eyebrow ? 'h3' : 'h2'
  }, primaryPanel))), /*#__PURE__*/_react.default.createElement(PanelSpacer, {
    "aria-hidden": "true"
  }), trustpilotUrl && /*#__PURE__*/_react.default.createElement(Trustpilot, {
    "data-cy": "trustpilot"
  }, /*#__PURE__*/_react.default.createElement(TrustpilotLink, {
    rating: rating,
    trustpilotLogo: trustpilotLogo,
    trustpilotUrl: trustpilotUrl
  })));
}
var _default = exports.default = PrimaryPanel;
PrimaryPanel.propTypes = {
  primaryPanel: _propTypes.default.object
};